export default {
  ROOM_CREATE: '/api/naqt/room/create',                          // 创建房间

  ROOM_LIST: '/api/naqt/room/getRoomList',                       // 房间列表

  ROOM_INTO: '/api/naqt/room/into',                              // 进入房间

  ROOM_INFO: '/api/naqt/room/getRoom',                           // 房间详情

  ROOM_KICK: '/api/naqt/room/kick',                              // 踢出房间

  ROOM_READY: '/api/naqt/room/ready',                            // 准备

  ROOM_START: '/api/naqt/room/start',                            // 开始比赛

  QUESTION_BANK: '/api/naqt/getNAQTQuestionBank',                // 问题集合

  QUESTION_CREATE: '/api/naqt/createNAQTQuestions',              // 问题集合

  CREAT_CHEATGROUP: '/api/im/chatGroup/createChatGroup',         // 创建聊天组别

  CHECK_USERSTATUS: '/api/naqt/room/checkUserStatus',            // 校验能否进入房间

  ROOM_EXIT: '/api/naqt/room/exit',                              // 退出房间

  NAQT_GET_QUESTIONS: '/api/naqt/getNAQTQuestions',              // 教练获取房间信息

  NAQT_SAVE_QUESTION: '/api/naqt/saveExamQuestion',              // 提交每一题的分数

  NAQT_START_BUZZING: '/api/naqt/startBuzzing',                  // 开始抢答

  NAQT_RACE_EXAM: '/api/naqt/raceExamQuestion',                  // 点击抢答按钮

  NAQT_NEXT_EXAM: '/api/naqt/nextExamQuestion',                  // 去下一题

  NAQT_GET_REPORT: '/api/naqt/getReport',                        // 获取naqt成绩

  NAQT_ROOM_END: '/api/naqt/room/end',                         // 房间结束

  NAQT_UPDATE_AVATAR: '/api/test/battle/updateAvatar',              // 修改用户头像

  NAQT_GETBATTLEINFO: '/api/test/battle/getBattleInfo'       // 查询状态
}



// WEBPACK FOOTER //
// ./src/assets/api/constant/naqt.js